import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import { ArrayField, DateField, Labeled, Show, SimpleShowLayout, SingleFieldList, TextField } from "react-admin";
import { useMediaQuery } from "@mui/material";
import { Grid } from "@mui/material";
import { settings } from "app";
import UserField from "server/components/Fields/UserField";
import { SectionTitle } from "features/SectionTitle";

const ShowHealthcareCampaign = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли на кампания за здравни грижи"
      actions={<BackButtonToolbar />}
    >
      <SectionTitle
        title="Основна информация"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <SimpleShowLayout>
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Година">
              <TextField source="coursesYear" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Курсове">
              <ArrayField source="courses">
                <SingleFieldList linkType={false}>
                  <TextField source="nameBg" />
                </SingleFieldList>
              </ArrayField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Старт на кампания">
              <DateField
                locales="bg-BG"
                source="applicationStartTimestamp"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Край на кампания">
              <DateField
                locales="bg-BG"
                source="applicationEndTimestamp"
              />
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Създадено от">
              <UserField source="createdByUserId" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Създадено на">
              <DateField
                locales="bg-BG"
                source="createdOn"
              />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowHealthcareCampaign;
